import { z } from 'zod';

const text = z.string().trim().min(1).max(4000);
export const terminationInput = z.object({
  noticeDate: z.iso.date(),
  effectiveDate: z.iso.date(),
  reason: text,
  propertyReturn: text,
  finalCompensation: text,
  additionalNotes: z.string().trim().max(4000).default(''),
  signerName: z.string().trim().min(1).max(120),
  signerTitle: z.string().trim().min(1).max(120),
  confirmed: z.literal(true),
});
export type TerminationInput = z.infer<typeof terminationInput>;
